import {
  FETCH_SONG_MODELS_REQUEST,
  FETCH_SONG_MODELS_SUCCESS,
  FETCH_SONG_MODELS_FAILURE,
  ADD_SONG_MODEL_REQUEST,
  ADD_SONG_MODEL_SUCCESS,
  ADD_SONG_MODEL_FAILURE,
  UPDATE_SONG_MODEL_REQUEST,
  UPDATE_SONG_MODEL_SUCCESS,
  UPDATE_SONG_MODEL_FAILURE,
  DELETE_SONG_MODEL_REQUEST,
  DELETE_SONG_MODEL_SUCCESS,
  DELETE_SONG_MODEL_FAILURE
} from '../types/authTypes';

const initialState = {
  items: [],
  total: 0,
  loading: false,
  error: null
};

const songModelsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SONG_MODELS_REQUEST:
    case ADD_SONG_MODEL_REQUEST:
    case UPDATE_SONG_MODEL_REQUEST:
    case DELETE_SONG_MODEL_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case FETCH_SONG_MODELS_SUCCESS:
      return {
        ...state,
        items: action.payload.items || [],
        total: action.payload.objects.total || 0,
        loading: false,
        error: null
      };

    case ADD_SONG_MODEL_SUCCESS:
      return {
        ...state,
        items: [...state.items, action.payload],
        total: state.total + 1,
        loading: false,
        error: null
      };

    case UPDATE_SONG_MODEL_SUCCESS:
      return {
        ...state,
        items: state.items.map(songModel =>
          songModel.id === action.payload.id ? action.payload : songModel
        ),
        loading: false,
        error: null
      };

    case DELETE_SONG_MODEL_SUCCESS:
      return {
        ...state,
        items: state.items.filter(songModel => songModel.id !== action.payload),
        total: state.total - 1,
        loading: false,
        error: null
      };

    case FETCH_SONG_MODELS_FAILURE:
    case ADD_SONG_MODEL_FAILURE:
    case UPDATE_SONG_MODEL_FAILURE:
    case DELETE_SONG_MODEL_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    default:
      return state;
  }
};

export default songModelsReducer; 